import React, { useMemo } from "react";
import { FieldError } from "../FieldError";
import { InputComponent } from "../input-types";
import { getDataset, getInputCss, getInputSettings } from "../input-utility";

type Props = {
  className?: string;
  children?: React.ReactNode;
  prompt?: string | boolean;
  includeBlank?: boolean;
  error?: string | boolean;
};

export const Select: InputComponent<HTMLSelectElement, Props> = (
  props: Props,
) => {
  const css = getInputCss(props.error, "c-form-field select", props.className);
  const dataset = useMemo(() => getDataset(props), [props]);
  const inputSettings = getInputSettings(props);

  return (
    <div>
      <select {...dataset} {...inputSettings} className={css}>
        {props.prompt && <option>選択してください</option>}
        {props.includeBlank && <option value="" />}
        {props.children}
      </select>
      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
